// arm-price.js
document.addEventListener("DOMContentLoaded", function () {
  const prices = {
    price1: { //ドット、プレーン細、ウェーブ
      k10: "K10YG 89,800円〜",
      k18: "K18 149,800円〜",
      pt900: "Pt900 124,800円〜"
    },
    price2: { //アンティーク、シグナル、ヘリンボーン、プレーン、テーパー、ツイスト
      k10: "K10YG 104,800円〜",
      k18: "K18 176,800円〜",
      pt900: "Pt900 144,800円〜"
    },
    price3: {//レスピレーション、グルーヴ、ポインティ6x3、フルールAB
      k10: "K10YG 109,800円〜",
      k18: "K18 185,800円〜",
      pt900: "Pt900 150,800円〜"
    },
    price4: {//ハフエタ四本爪3mm7pcs、ポインティ8x4
      k10: "K10YG 119,800円〜",
      k18: "K18 203,800円〜",
      pt900: "Pt900 163,800円〜"
    },
    price5: {//フレア、フルールC
      k10: "K10YG 114,800円〜",
      k18: "K18 194,800円〜",
      pt900: "Pt900 157,800円〜"
    },
    price6: {//パレス、プランプ、フラット3mm
      k10: "K10YG 137,800円〜",
      k18: "K18 236,800円〜",
      pt900: "Pt900 186,800円〜"
  },
      price9: {//フラット5mm、ハフエタ2.1mm14pcs
      k10: "K10YG 149,800円〜",
      k18: "K18 259,800円〜",
      pt900: "Pt900 202,800円〜"
  },
      price8: {//ハフエタミル、シールド、ピラー
      k10: "K10YG 126,800円〜",
      k18: "K18 216,800円〜",
      pt900: "Pt900 172,800円〜"
  },
    price7: {//ネックレス、ピアス
      k10: "K10YG 27,800円〜",
      k18: "K18 43,000円〜",
      pt900: "Pt900 32,800円〜"
    }    
  };

  Object.entries(prices).forEach(([group, metals]) => {
    document.querySelectorAll(`.k10-${group}`).forEach(el => el.textContent = metals.k10);
    document.querySelectorAll(`.k18-${group}`).forEach(el => el.textContent = metals.k18);
    document.querySelectorAll(`.pt900-${group}`).forEach(el => el.textContent = metals.pt900);
  });
});
